<template>
  <v-chip class="ma-1"
          dark
          small
          :color="statusColor">
    <v-icon left
            small>
      mdi-access-point
    </v-icon>
    {{ statusTile }}
  </v-chip>
</template>

<script>
export default {
  name: "CustomerStatusChip",
  props: ['customerCompanyId', 'customerStatusCompany', 'customerStatusIndividual'],
  data() {
    return {
      statusId:null,
      statusTile: null,
      statusColor: null,
      isIndividual: null,
    }
  },
  created() {
    this.statusId = this.customerCompanyId > 0 ? this.customerStatusCompany : this.customerStatusIndividual;
    this.isIndividual = this.customerCompanyId === 0;
    if (this.isIndividual) {
      switch (this.statusId) {
        case 0: // IndividualTerminated
          this.statusTile = "Terminated"
          this.statusColor = "red"
          break;

        case 1: // Active
          this.statusTile = "Active"
          this.statusColor = "green"
          break;

        case 2: // Cancelled
          this.statusTile = "Cancelled"
          this.statusColor = "red"
          break;

        case 3: //Suspended
          this.statusTile = "Suspended"
          this.statusColor = "orange";
          break;

        case 4: //Pending
          this.statusTile = "Pending"
          this.statusColor = "orange";
          break;

      }
    } else {
      switch (this.statusId) {
        case 1: // Active
          this.statusTile = "Active"
          this.statusColor = "green"
          break;

        case 0: //Corp Terminated
          this.statusTile = "Terminated"
          this.statusColor = "red";
          break;

        case 3: //Corp Suspended
          this.statusTile = "Suspended"
          this.statusColor = "red";
          break;
      }
    }
  },
}
</script>

<style scoped>

</style>
